import React from 'react';
import classnames from 'classnames';
import { TThumbnail } from '../UploadingFileThumbnail.types';
import styles from '../UploadingFileThumbnail.scss';

export const Video: TThumbnail = ({ fallbackImageClassName }) => (
  <div className={classnames(styles.contentWrapper, styles.video)} data-hook="uploading-file-thumbnail-video">
    <div className={classnames(styles.content, fallbackImageClassName)} />
  </div>
);
